class TeaCodeModal {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.modal = this.section.querySelector('[data-tea-modal]');
    this.triggers = this.section.querySelectorAll('[data-modal-trigger]');
    this.closeButtons = this.section.querySelectorAll('[data-modal-close]');
    this.lastTrigger = null;

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);

    this.init();
  }

  init() {
    if (!this.modal) return;

    // Open triggers
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick);
    });

    // Close buttons (includes close icon and Got It button)
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.handleCloseClick);
    });

    // Background click
    this.modal.addEventListener('click', this.handleOutsideClick);

    // Global Keydown
    document.addEventListener('keydown', this.handleKeyDown);
  }

  destroy() {
    this.triggers.forEach((trigger) => {
      trigger.removeEventListener('click', this.handleTriggerClick);
    });

    this.closeButtons.forEach((btn) => {
      btn.removeEventListener('click', this.handleCloseClick);
    });

    if (this.modal) {
      this.modal.removeEventListener('click', this.handleOutsideClick);
    }

    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleTriggerClick(e) {
    this.lastTrigger = e.currentTarget;
    this.open();
  }

  handleCloseClick() {
    this.close();
  }

  handleOutsideClick(e) {
    if (e.target === this.modal) {
      this.close();
    }
  }

  handleKeyDown(e) {
    if (!this.modal.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key === 'Tab') {
      this.trapFocus(e);
    }
  }

  trapFocus(e) {
    const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  open() {
    const scrollbarWidth = this.getScrollbarWidth();

    this.modal.classList.add('is-open');
    this.section.classList.add('is-modal-open');
    this.modal.setAttribute('aria-hidden', 'false');

    if (this.lastTrigger) {
      this.lastTrigger.setAttribute('aria-expanded', 'true');
    }

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    document.body.style.overflow = 'hidden';

    // Focus first element
    const firstFocusable = this.modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      setTimeout(() => firstFocusable.focus(), 100);
    }
  }

  close() {
    this.modal.classList.remove('is-open');
    this.section.classList.remove('is-modal-open');
    this.modal.setAttribute('aria-hidden', 'true');

    if (this.lastTrigger) {
      this.lastTrigger.setAttribute('aria-expanded', 'false');
      this.lastTrigger.focus();
    }

    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }
}
